import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TermoDialog, { useOrganizador } from './TermoDialog';

// Termo de uso / LGPD do cadastro. Texto genérico: o organizador é o nome do tenant (branding).
function ConfirmacaoCadastroProdutorDialog({ open, onClose, setChecked }) {
  const { t } = useTranslation();
  const organizador = useOrganizador();

  return (
    <TermoDialog
      open={open}
      onClose={onClose}
      onAceitar={setChecked}
      titulo={t('Terms of Service and Privacy Policy')}
      textoAceitar={t("I've read and agreed to the terms and privacy policy")}
    >
      <Typography variant="body2" color="text.primary" paragraph>
        {t('termos.lgpd.tratamento', { organizador })}
      </Typography>
      <Typography variant="body2" color="text.primary" paragraph>
        <Trans i18nKey="termos.lgpd.compartilhamento" values={{ organizador }} components={{ b: <b /> }} />
      </Typography>
      <Typography variant="body2" color="text.primary" paragraph sx={{ mb: 0 }}>
        {t('By continuing, you agree to the Terms of Service and Privacy Policy.')}
      </Typography>
    </TermoDialog>
  );
}

export default ConfirmacaoCadastroProdutorDialog;
